import { Result, Spin, Button, Modal } from 'antd'
import { useEffect, useState } from 'react'
import { clearSpace } from 'Services/WeaverUtils'
import ACLService from 'Services/ACL_Service'
import { LoadingOutlined } from '@ant-design/icons'

ClearSpace = ({ space }) ->

  [isModalVisible, setIsModalVisible] = useState(false)
  [feedback, setFeedback]             = useState(undefined)
  [isDisabled, setIsDisabled]         = useState(true)

  useEffect( ->
    ( ->
      setIsDisabled(
        !(await ACLService.checkHasWriteAccess(space))
      )
    )()
    undefined
  , [])

  clear = ->
    setFeedback({
      type: 'info'
      icon: <LoadingOutlined />
      title: 'Clearing the space...'
      message: 'This could take several minutes depending on the size of the database'
    })

    try
      await clearSpace(space)
      setFeedback({
        type: 'success'
        title: 'Done!'
        message: 'The space has successfully been cleared'
      })
    catch e
      setFeedback({
        type: 'error'
        title: 'Something went wrong!'
        message: e.message
      })

  <>
    <Button
      style={{ marginBottom: 20 }}
      onClick={-> setIsModalVisible(true)}
      disabled={isDisabled}
    >Clear space</Button>
    <Modal
      visible={isModalVisible}
      footer={null}
      onCancel={ -> setIsModalVisible(false)}
      destroyOnClose={true}
    >
      {
        if feedback?
          <Result
            status={feedback.type}
            icon={feedback.icon}
            title={feedback.title}
            subTitle={feedback.message}
          />
        else
          <Result
            status="warning"
            title="Are you sure?"
            subTitle="This operation will remove all data from the space. This operation is not reversible."
            extra={<Button type="primary" onClick={ -> clear() }>Yes, I'm sure.</Button>}
          />
      }
    </Modal>
  </>

export default ClearSpace
